import { ebonSellingPriceTotal, createEbon, compareEbons } from './ebonUtils';

const mergeItems = (acc, next) => {
    const found = acc.findIndex(item => item.value === next.value);
    // if (DEBUG) console.log({ found }, next.value);

    if (found > -1) acc[found].stock += 1;
    else acc.push({ ...next });
    // if (DEBUG) console.log(acc);
    // if (DEBUG) console.log(next);
    return acc;
};

const vendorClusterMap = {
    Fnac: 'Fnac / Darty',
    Darty: 'Fnac / Darty'
};

export const getVendorName = name => vendorClusterMap[name] || name;

export const createOrder = ({ orderDate, ebonList, id, billNumber, partnerId }, ebonPartners) => {
    const partner =
        ebonPartners.length > 0 && ebonPartners.filter(partner => partner.id === partnerId);
    const vendorName = partner.length > 0 && partner[0].name;

    const items = ebonList.map(ebon => createEbon({ ...ebon, vendorName })).sort(compareEbons);
    return {
        vendorName,
        id,
        date: orderDate,
        items,
        mergedItems: items.reduce(mergeItems, []).sort(compareEbons),
        total: ebonList.reduce(ebonSellingPriceTotal, 0),
        billNumber,
        partnerId
    };
};



// WEBPACK FOOTER //
// ./src/utils/ebonOrderUtils.js